import sanityClient from "@sanity/client";

export default sanityClient({
    apiVersion: "v2022-08-04",
    projectId: "k49sfmj8", // find this at manage.sanity.io or in your sanity.json
    dataset: import.meta.env.MODE === "development" ? "development" : "production",
    // dataset: "development", // this is from those question during 'sanity init'
    useCdn: true,
});
